import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Screen } from "../Screen";
import PulseIcon from "@common/images/mc_settings_pulse.svg";
import { Image } from "@learningblocks/shared-components/lib/Image";
import { Input } from "../Input";

import "./style.scss";

const TRANSLATION_KEY = {
  RPM_INPUT: "RPMInput.string",
};

export function RPMDisplay(props) {
  const { t } = useTranslation();

  return (
    <Screen className="mc_settings_rpmDisplay">
      <div className="mc_settings_rpmDisplay_inputBlock">
        <Input
          className="mc_settings_rpmDisplay_inputBlock_input"
          value={props.displayValue}
          setValue={props.setRPM}
          ariaLabel={t(TRANSLATION_KEY.RPM_INPUT, { rpm: props.displayValue })}
        />
        <Image
          className="mc_settings_rpmDisplay_inputBlock_pulseIcon"
          src={PulseIcon}
          alt=""
        />
      </div>
    </Screen>
  );
}

RPMDisplay.propTypes = {
  /**
   * value to be displayed in RPM display
   */
  displayValue: PropTypes.number,
  /**
   * callback function to set the value of ROM
   */
  setRPM: PropTypes.func,
};

RPMDisplay.defaultProps = {
  displayValue: 0,
};
